import styled, { css } from 'styled-components';
/**
 * Video Aspect Ratio Styles
 */
export const videoAspectRatioStyles = () => css `
	aspect-ratio: 16 / 9;
	width: 100%;
`;
/**
 * Video Aspect Ratio Polyfill Styles
 */
export const videoAspectRatioOverrideStyles = () => css `
	height: 100%;
	width: 100%;
	left: 0;
	top: 0;
	position: absolute;
`;
/**
 * Video Container
 */
export const videoContainerStyles = ({ theme }) => css `
	width: 100%;
	height: 100%;
	background: ${theme.colors.light.bgMediaPlaceholder};

	/* Overrides for browsers incompatible with aspect-ratio, mainly Safari iOS 14 and below */
	@supports not (aspect-ratio: 1) {
		padding-bottom: 56.25%; /* VooDoo code :) */
		position: relative;

		${VideoIframe} {
			${videoAspectRatioOverrideStyles}
		}
	}
`;
export const VideoContainer = styled.div `
	${videoContainerStyles}
`;
/**
 * Video Iframe
 */
export const videoIframeStyles = () => css `
	border: 0;
	box-shadow: 0;
`;
export const VideoIframe = styled.iframe `
	${videoIframeStyles}
	${videoAspectRatioStyles}
`;
